'use client'

import type { FilterOption } from '@/lib/directory/build-filter-options'
import { tw } from '@/lib/utils'

interface ChoicePillProps {
  option: FilterOption
  selected: boolean
  onToggle: (value: string) => void
}

// A toggle pill for the single-pick facets (type, best for, hearing loss, how
// you buy): the label, then the family count in a quieter weight.
export const ChoicePill = ({ option, selected, onToggle }: ChoicePillProps) => (
  <button
    type="button"
    data-tracking="ignore"
    aria-pressed={selected}
    onClick={() => onToggle(option.value)}
    className={tw(
      'focus-visible:outline-lapis inline-flex min-h-[40px] cursor-pointer items-center gap-1.5 rounded-full border px-3.5 text-[14px] font-medium transition-colors focus-visible:outline-2 focus-visible:outline-offset-2',
      selected ? 'border-navy bg-navy text-white' : 'border-navy/20 text-navy hover:border-navy bg-white'
    )}
  >
    {option.label ?? option.value}
    <span className={tw('text-[12px] tabular-nums', selected ? 'text-white/70' : 'text-navy/50')}>{option.count}</span>
  </button>
)
